import { environment } from './environments/environment';

export const sentryOptions = {
  dsn: environment.dsn,
  logErrors: true,
  tracesSampleRate: 1.0,
  environment: environment.sentryEnvironment,
};
